import { clientEnv } from "../env";

export type MediaAspectRatio = "16:9" | "9:16" | "1:1";
export type MediaJobStatus = "queued" | "running" | "completed" | "failed";

export interface GeneratedImage4K {
  readonly kind: "image";
  readonly provider: "openai";
  readonly model: string;
  readonly mimeType: "image/png";
  readonly base64: string;
  readonly width: number;
  readonly height: number;
  readonly resolution: "4K";
  readonly verified4k: true;
  readonly createdAt: string;
}

export interface MediaImageJob {
  readonly id: string;
  readonly status: MediaJobStatus;
  readonly error?: string;
  readonly result?: GeneratedImage4K;
}

export class MediaClientError extends Error {
  constructor(readonly status: number, message: string) {
    super(message);
    this.name = "MediaClientError";
  }
}

export async function createImage4KJob(input: {
  token: string;
  organizationId: string;
  prompt: string;
  projectName: string;
  aspectRatio: MediaAspectRatio;
}): Promise<MediaImageJob> {
  const response = await fetch(`${clientEnv.apiBaseUrl}/media/images/jobs`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${input.token}`,
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      organizationId: input.organizationId,
      prompt: input.prompt,
      projectName: input.projectName,
      aspectRatio: input.aspectRatio,
      confirmCredits: true
    })
  });
  return readJob(response);
}

export async function getMediaJob(token: string, jobId: string): Promise<MediaImageJob> {
  const response = await fetch(`${clientEnv.apiBaseUrl}/media/jobs/${jobId}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return readJob(response);
}

async function readJob(response: Response): Promise<MediaImageJob> {
  let payload: MediaImageJob | { error?: string };
  try {
    payload = await response.json() as MediaImageJob | { error?: string };
  } catch {
    throw new MediaClientError(response.status, "Respuesta multimedia no válida.");
  }
  if (!response.ok) {
    throw new MediaClientError(response.status, "error" in payload && payload.error
      ? payload.error
      : "No se pudo procesar la imagen.");
  }
  return payload as MediaImageJob;
}
